import React from "react";
import { PLATFORMS } from "../publicEmployees/socialPlatforms";

const isWebLink = (url) => /^https?:\/\//i.test(url || "");

// A row of social icons for the card. On the public card they are links that open in a new
// tab; in the editor (interactive={false}) they are only a preview of what visitors will see.
const SocialIconRow = ({ links, color = "#ffffff", size = 22, interactive = true, className = "" }) => {
  const items = (Array.isArray(links) ? links : [])
    .map((link) => ({ link, platform: PLATFORMS.find((p) => p.key === link?.platform) }))
    .filter(({ link, platform }) => platform && isWebLink(link.url));

  if (items.length === 0) return null;

  return (
    <div className={`flex flex-wrap justify-center gap-4 ${className}`}>
      {items.map(({ link, platform }) => {
        const Icon = platform.Icon;
        const icon = <Icon aria-hidden="true" style={{ fontSize: size }} />;
        return interactive ? (
          <a
            key={platform.key}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={platform.label}
            title={platform.label}
            style={{ color }}
            className="hover:opacity-80 transition-opacity"
          >
            {icon}
          </a>
        ) : (
          <span key={platform.key} aria-label={platform.label} title={platform.label} style={{ color }}>
            {icon}
          </span>
        );
      })}
    </div>
  );
};

export default SocialIconRow;
